// Hoch/Runter-Verschieben von ILOs — bewusst Buttons statt Drag&Drop.
// Wizard: TLA/AT-Links sind index-basiert (linked_ilo_indices zeigen auf
// Positionen im ilos-Array) und müssen beim Tausch mitremappt werden.
// Editor: Links sind UUID-basiert, dort genügt der Tausch der positions.

/** Tauscht die Einträge an i und j (neues Array, Input unverändert). */
export function swapItems<T>(items: T[], i: number, j: number): T[] {
  const next = [...items];
  [next[i], next[j]] = [next[j], next[i]];
  return next;
}

/** Remappt Index-Verweise nach einem Tausch von i und j: Verweise auf i
 *  zeigen danach auf j und umgekehrt, alle anderen bleiben unverändert. */
export function remapSwappedIndices(indices: number[], i: number, j: number): number[] {
  return indices.map((x) => (x === i ? j : x === j ? i : x));
}
